// <!-- Google Tag Manager -->
const GTM_CODE = document.currentScript.getAttribute('gtm');
((w, d, s, l, i) => {
  const f = d.getElementsByTagName(s)[0];
  const j = d.createElement(s);
  const dl = 'dataLayer' !== l ? `&l=${l}` : '';
  w[l] = w[l] || [];
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  j.async = true;
  j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
  f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', GTM_CODE);
// <!-- End Google Tag Manager -->